import {
  createResource,
  getResource,
} from '@/resource/resource'
import { prefixAPI } from '@/resource/api'
import { getCookie } from '@/utils/cookies'

const MODEL_PREFIX = 'vacancies'

const SETTINGS_URL = prefixAPI('/settings/', MODEL_PREFIX)
const LIST_URL = prefixAPI('/list/', MODEL_PREFIX)
const DETAIL_URL = prefixAPI('/{slug}/', MODEL_PREFIX)
const RESPONSE_CREATE_URL = prefixAPI('/response/create/', MODEL_PREFIX)
const CONFIDENTIALITY_URL = prefixAPI('/confidentiality/', MODEL_PREFIX)
const TERMSOFUSE_URL = prefixAPI('/termsofuse/', MODEL_PREFIX)

export const vacancySettingsResource = createResource(SETTINGS_URL, getResource)
export const vacancyListResource = createResource(LIST_URL, getResource)
export const vacancyDetailResource = createResource(DETAIL_URL, getResource)
export const vacancyConfidentialityResource = createResource(CONFIDENTIALITY_URL, getResource)
export const vacancyTermsofuseResource = createResource(TERMSOFUSE_URL, getResource)

export async function vacancyResponseCreate(formData) {
  const response = await fetch(RESPONSE_CREATE_URL, {
    method: 'POST',
    body: formData,
    headers: {
      'X-CSRFToken': getCookie('csrftoken'),
      'X-Requested-With': 'XMLHttpRequest',
      'Accept-Language': window.language || 'uk',
    },
    credentials: 'include',
  })
  return response
}
